import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import AttendanceBookApprovalComponent from "./Component/AttendanceBookApprovalComponent";
import { API_URL } from "../../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { toast } from "react-toastify";
import moment from "moment";

const AttendanceBookApproval = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(updateNavbarHeading("Attendance Book Approval"));
  }, []);

  const UserContactID = JSON.parse(
    localStorage.getItem("user")
  )?.DefaultContactID;
  const [calendarMonthOption, setCalendarMonthOption] = useState([]);
  console.log("calendarMonthOption", calendarMonthOption);

  const intialFilterData = [
    { label: "Branch", value: 2 },
    {
      label: "Calendar Month",
      value: calendarMonthOption.length > 0 ? calendarMonthOption[0].value : '',
    },
    { label: "HR Executive", value: UserContactID },
  ];

  const [filterFormData, setFilterData] = useState(intialFilterData);
  console.log("filterFormData", filterFormData);
  const [searchTerm, setSearchTerm] = useState("");
  const [attendanceBookApprovalData, setAttendanceBookApprovalData] = useState(
    []
  );
  console.log('attendanceBookApprovalData', attendanceBookApprovalData);

  const [loading, setLoading] = useState(true);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [branchOption, setBranchOption] = useState([]);
  const [hrExecutiveOption, setHRExecutiveOption] = useState([]);
  const [shiftOption, setShiftOption] = useState([]);
  const [employeeOption, setEmplooyeeOption] = useState([]);
  const [attendanceStatusOptions, setAttendanceStatusOptions] = useState([]);

  const calendarMonthData = filterFormData.find(
    (o) => o.label === "Calendar Month"
  );

  const selectedMonth = calendarMonthOption?.find(
    (ele) => ele?.value === calendarMonthData?.value
  ) || {
    totalDays: 31,
    ShortMonth: "Day",
  };

  const columns = {
    tmpEmployeeName: {
      text: "Employee",
      align: "start",
      visible: true,
      width: "150px",
    },
    PresentDays: {
      text: "Present Days",
      align: "center",
      visible: true,
      width: "100px",
    },
    AbsentDays: {
      text: "Absent Days",
      align: "center",
      visible: true,
      width: "100px",
    },
    Remark: {
      text: "Remark",
      align: "center",
      visible: true,
      width: "200px",
      type: "Text",
    },
  };

  // Dynamically generate columns for each day of the selected month
  const finalColumns = {
    ...columns, // Ensure existing columns are preserved
    ...Array.from({ length: selectedMonth.totalDays }, (_, i) => ({
      [`tmpDay${i + 1}`]: {
        text: `${i + 1} ${selectedMonth.ShortMonth}`,
        align: "center",
        visible: true,
        width: "80px",
        // type: "Select"
      },
    })).reduce((acc, cur) => ({ ...acc, ...cur }), {}), // Merge day columns correctly
  };

  useEffect(() => {
    fetchGetDetails();
  }, []);

  const fetchGetDetails = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/attendance-book-approval/add-page/details`
      );
      SetApiStatus(response?.status);
      if (response?.status == 200) {
        const cleanedData = response?.data;

        const branchOpt = cleanedData?.branches?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setBranchOption(branchOpt);

        const monthOpt = cleanedData?.calendermonth?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
          totalDays: ele?.totalDays,
          ShortMonth: ele?.ShortMonth,
        }));
        setCalendarMonthOption(monthOpt);
        setFilterData((prevFilterData) =>
          prevFilterData.map((item) =>
            item.label === "Calendar Month" ? { ...item, value: monthOpt[0] || null } : item
          )
        );
        const employeeOpt = cleanedData?.employeelist?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setEmplooyeeOption(employeeOpt);
        const shiftOpt = cleanedData?.shift?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setShiftOption(shiftOpt);
        const executivesOpt = cleanedData?.executives?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setHRExecutiveOption(executivesOpt);

        const attendanceStatusOpt = cleanedData?.attendanceStatus?.map(
          (ele) => ({
            value: ele?.value,
            label: ele?.text,
            color: ele?.color,
          })
        );
        setAttendanceStatusOptions(attendanceStatusOpt);
        
      }
    } catch (error) {
      console.error("Error while submitting data:", error);
      if (error.response && error.response.data && error.response.data.error) {
        toast.error(error.response.data.error, {
          position: "top-right",
        });
        console.error("Server responded with status:", error.response.status);
        console.error("Response data:", error.response.data);
      }
    }
  };

  const formDatas = [
    {
      name: "Branch",
      type: "Select",
      options: [...branchOption],
    },
    {
      name: "Calendar Month",
      type: "Select",
      options: [...calendarMonthOption],
    },
    {
      name: "Employee",
      type: "Select",
      options: [...employeeOption],
    },
    {
      name: "HR Executive",
      type: "Select",
      visible: true,
      options: [...hrExecutiveOption],
    },
    {
      name: "Shift",
      type: "Select",
      options: [...shiftOption],
    },
    {
      name: "Remark",
      type: "Text",
      // options: [...shiftOption],
    },
    {
      name: "Current Month Joiners",
      type: "Checkbox",
    },
    {
      name: "Current Month Exits",
      type: "Checkbox",
    },
  ];
  const filteredBranchValue =
    filterFormData.find((o) => o.label === "Branch")?.value || 0;
  const filteredCalendarMonthValue =
    filterFormData.find((o) => o.label === "Calendar Month")?.value || 0;
  const filteredEmployeeValue =
    filterFormData.find((o) => o.label === "Employee")?.value || 0;
  const filteredHRExecutiveValue =
    filterFormData.find((o) => o.label === "HR Executive")?.value || 0;
  const filteredShiftValue =
    filterFormData.find((o) => o.label === "Shift")?.value || 0;
  const filteredRemarkValue =
    filterFormData.find((o) => o.label === "Remark")?.value || ""; // Assuming it's a text field
//  const filteredCurrMonJoinersValue =
//     filterFormData.find((o) => o.label === "Current Month Joiners")?.value || false;
//   const filteredCurrMonRelValue =
//     filterFormData.find((o) => o.label === "Current Month Exits")?.value || false;
    
  const [attendanceBookHeaderData, setAttendanceBookHeaderData] = useState([]);

  const handleGetData = async () => {
    SetApiStatus(undefined)

    // Get all filter values at once
    const getFilterValue = (label) =>
      filterFormData.find((o) => o.label === label)?.value;

    const calendarMonth = getFilterValue("Calendar Month");
    if (!calendarMonth) {
      toast.error("Please select Calendar Month");
      return;
    }

    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/attendance-book-approval?P_ShiftID=${filterFormData.find((o) => o.label === "Shift")
          ? filterFormData.find((o) => o.label === "Shift").value
          : 0
        }&P_MonthID=${filterFormData.find((o) => o.label === "Calendar Month")
          ? filterFormData.find((o) => o.label === "Calendar Month").value
            .value ||
          filterFormData.find((o) => o.label === "Calendar Month").value
          : 0
        }&P_EmployeeID=${
          filteredEmployeeValue
        }&P_MonthID=${filterFormData.find((o) => o.label === "Calendar Month")
          ? filterFormData.find((o) => o.label === "Calendar Month").value
            .value ||
          filterFormData.find((o) => o.label === "Calendar Month").value
          : 0
        }&P_NewJoiner=${filterFormData.find((o) => o.label === "Current Month Joiners")
          ? filterFormData.find((o) => o.label === "Current Month Joiners").value
            .value ||
          filterFormData.find((o) => o.label === "Current Month Joiners").value
          : 0
        }&P_Exits=${filterFormData.find((o) => o.label === "Current Month Exits")
          ? filterFormData.find((o) => o.label === "Current Month Exits").value
            .value ||
          filterFormData.find((o) => o.label === "Current Month Exits").value
          : 0
        }
         `
        // `${API_URL}rujul/attendance-book-approval?P_ShiftID=&P_MonthID=124&P_EmployeeID=&P_Month=Feb 2024`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const cleanedData = response?.data;
        console.log('cleanedData', cleanedData);


        setAttendanceBookHeaderData(cleanedData?.attendanceBook);

        setAttendanceBookApprovalData(cleanedData?.attendanceData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const [newSelectedStatus, setNewSelectedStatus] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});
  const [selectedResources, setSelectedResources] = useState([]);

  const handleColumnSelect = (selectedOption, item, columnName) => {
    const updatedValue = Number(selectedOption.value).toFixed(4);

    setAttendanceBookApprovalData((prevData) =>
      prevData.map((row) =>
        row.LineNo === item.LineNo
          ? { ...row, [columnName]: updatedValue }
          : row
      )
    );

    setSelectedItem(item);
    setNewSelectedStatus(updatedValue);

    setSelectedResources((prevResources) =>
      prevResources.map((resource) =>
        resource.LineNo === item.LineNo
          ? { ...resource, [columnName]: updatedValue, IsConfirmed: 1 }
          : resource
      )
    );
  };

  // Handle 'Select All' checkbox change
  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;
    setSelectAllChecked(checked);

    if (checked) {
      const newSelectedItems = {};
      const newSelectedResources = [];

      attendanceBookApprovalData.forEach((item) => {
        newSelectedItems[item.EmployeeID] = true; // Changed from LineNo to EmployeeID
        newSelectedResources.push({ ...item, IsConfirmed: 1 });
      });

      setSelectedItems(newSelectedItems);
      setSelectedResources(newSelectedResources);

      // Update the main data to reflect changes
      setAttendanceBookApprovalData((prevData) =>
        prevData.map((item) => ({ ...item, IsConfirmed: 1 }))
      );
    } else {
      setSelectedItems({});
      setSelectedResources([]);

      // Update the main data to reflect changes
      setAttendanceBookApprovalData((prevData) =>
        prevData.map((item) => ({ ...item, IsConfirmed: 0 }))
      );
    }
  };

  const handleCheckboxChange = (event, id, item) => {
    const isChecked = event.target.checked;

    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = { ...prevSelectedItems, [id]: isChecked };

      // Check if all checkboxes are selected
      const allSelected = attendanceBookApprovalData.every(
        (resource) => updatedSelectedItems[resource.EmployeeID]
      );
      setSelectAllChecked(allSelected);

      return updatedSelectedItems;
    });

    setSelectedResources((prevSelectedResources) => {
      if (isChecked) {
        return [...prevSelectedResources, { ...item, IsConfirmed: 1 }];
      } else {
        return prevSelectedResources.filter(
          (resource) => resource.EmployeeID !== id
        );
      }
    });

    // Update attendanceBookApprovalData to reflect changes
    setAttendanceBookApprovalData((prevData) =>
      prevData.map((resource) =>
        resource.EmployeeID === id
          ? { ...resource, IsConfirmed: isChecked ? 1 : 0 }
          : resource
      )
    );
  };

  // Handle text input change for table column
  const handleTableRemark = (e, columnName, item) => {
    const updatedValue = e.target.value;

    setAttendanceBookApprovalData((prevData) =>
      prevData.map((obj) =>
        obj.LineNo === item.LineNo
          ? { ...obj, [columnName]: updatedValue }
          : obj
      )
    );

    setSelectedResources((prevResources) =>
      prevResources.map((resource) =>
        resource.LineNo === item.LineNo
          ? { ...resource, [columnName]: updatedValue }
          : resource
      )
    );
  };



  const [submitButtonStatus, setSubmitButtonStatus] = useState(false)



  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if selectedResources is empty, null, or undefined
    // if (!selectedResources || selectedResources.length === 0) {
    //   toast.error("Select at least one record", {
    //     position: "top-right",
    //   });
    //   return; // Stop execution if validation fails
    // }

    // // Check if selectedResources is empty, null, or undefined
    // if (!selectedResources || selectedResources.length === 0) {
    //   toast.error("Must have atleast one record in AttendanceBookApprovalLine.", {
    //     position: "top-right",
    //   });
    //   return; // Stop execution if validation fails
    // }



    setSubmitButtonStatus(true)
    setLoading(true);
    try {
      // Get Current Month Joiners value
      const getFilterValue = (label) =>
        filterFormData.find((o) => o.label === label)?.value;

      // Call the API to submit data
      const response = await PostServiceCaller(
        `${API_URL}rujul/attendance-book-approval`,
        {
          AttendanceBookApproval: {
            ID: attendanceBookHeaderData?.ID,
            MonthID: calendarMonthData?.value,
            RevisionNumber: attendanceBookHeaderData?.RevisionNumber,
            BranchID: filteredBranchValue,
            ExecutiveID: filteredHRExecutiveValue,
            ShiftID: filteredShiftValue,
            EmployeeID: filteredEmployeeValue,
            AttendanceStatus: 0,
            TXNDate: moment(new Date()).format("DD-MM-YYYY"),
            NewJoiners: getFilterValue("Current Month Joiners") === true ? 1 : 0,
            Exits: getFilterValue("Current Month Exits") === true ? 1 : 0,
          },
          AttendanceBookApprovalLine: { ...attendanceBookApprovalData },
        },
        "post"
      );

      if (response.status === 200) {
        setSubmitButtonStatus(false)

        toast.success("Data submitted successfully");
        setTimeout(() => {
          window.location.reload();

          handleGetData();
        }, 1000);
        setLoading(false);
      } else {
        setSubmitButtonStatus(false)

        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
        console.error("Response data:", response.data);
      }
    } catch (error) {
      setSubmitButtonStatus(false)

      if (error.name === "ValidationError") {
        console.error("Validation Error:", error);

        // Map validation errors to fields
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        //   setErrors(validationErrors);
      } else {
        console.error("Unexpected Error:", error);
      }
    } finally {
      setSubmitButtonStatus(false)

    }
  };


  const handleReset = async () => {
    //  SetApiStatus(undefined)


    setAttendanceBookApprovalData([])
    setFilterData([
      { label: "Branch", value: 2 },
      {
      label: "Calendar Month",
      value: null,
    },
      { label: "HR Executive", value: UserContactID },
    ])

    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/attendance-book-approval?P_ShiftID=${0}&P_MonthID=${0}&P_EmployeeID=${0}&P_NewJoiner=${0}&P_Exits=${0}
         `
        // `${API_URL}rujul/attendance-book-approval?P_ShiftID=&P_MonthID=124&P_EmployeeID=&P_Month=Feb 2024`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const cleanedData = response?.data;
        console.log('cleanedData', cleanedData);


        setAttendanceBookHeaderData(cleanedData?.attendanceBook);

        setAttendanceBookApprovalData(cleanedData?.attendanceData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }

  }

  return (
    <div className="container-fluid" id="skill_section">
      <div className=" rounded bg-white" id="skill-table-area">
        <div className="row mt-2">
          <AttendanceBookApprovalComponent
            data={attendanceBookApprovalData}
            columns={finalColumns}
            attendanceStatusOptions={attendanceStatusOptions}
            itemsPerPage={8}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            showIcon1={true}
            showIcon2={false}
            // loading={loading}
            showIcon3={false}
            isSubmitStatus={submitButtonStatus}
            showIcon4={true}
            isAddNewBtnRequired={true}
            handleAddNew={handleSubmit}
            isApiStatus={apiStatus}
            isRequiredStatus={true}
            showIcon5={false}
            formDatas={formDatas}
            filterFormData={filterFormData}
            handleGetData={handleGetData}
            isActionRequired={false}
            isFilterRequired={true}
            isCheckBoxRequired={true}
            handleReset={handleReset}
            handleTextBoxChange={handleTableRemark}
            // handleColumnSelect={handleColumnSelect}
            selectedResource={selectedResources}
            selectAllChecked={selectAllChecked}
            handleCheckboxChange={handleCheckboxChange}
            handleSelectAllChange={handleSelectAllChange}
            // handleIcon1={handleEdit}
            // handleIcon4={handleOpen}
            handleChange={handleChange}
            add
            more
            function
            icons={{
              Icon1: <i class="bi bi-pencil-square  icons"></i>,
              Icon2: <i class="bi bi-trash-fill icons"></i>,
              Icon3: <i class="bi bi-eye-fill icons"></i>,
              Icon4: <i class="bi bi-person-plus icons"></i>,
              Icon4Text: "Create Employee",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AttendanceBookApproval;